/**
 * Resolves the user-facing display name for an aiforme tool.
 * Returns displayName if it is a non-empty string, otherwise falls back to title.
 *
 * This is an isolated hotfix utility. To revert:
 * 1. Delete this file
 * 2. Remove the displayName field from AIForMeTool
 * 3. Revert call-site changes in RecentlyUsedCard, AiForMeItem, List.tsx
 */
export const resolveDisplayName = (tool: { displayName?: string; title: string }): string => {
  return tool.displayName?.trim() ? tool.displayName : tool.title;
};
